import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { CreateTermsTemplate, UpdateTermsTemplate } from '@trellis/shared'

import {
  createTermsTemplate,
  deleteTermsTemplate,
  listTermsTemplates,
  setDefaultTermsTemplate,
  updateTermsTemplate,
} from '@/requests/terms-templates/index.js'

export function useTermsTemplatesQuery() {
  return useQuery({
    queryKey: ['terms-templates'],
    queryFn: listTermsTemplates,
    staleTime: 60_000,
    select: (result) => result.data ?? [],
  })
}

export function useCreateTermsTemplateMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTermsTemplate) => createTermsTemplate(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['terms-templates'] }),
  })
}

export function useUpdateTermsTemplateMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTermsTemplate }) =>
      updateTermsTemplate(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['terms-templates'] }),
  })
}

export function useSetDefaultTermsTemplateMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => setDefaultTermsTemplate(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['terms-templates'] }),
  })
}

export function useDeleteTermsTemplateMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteTermsTemplate(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['terms-templates'] }),
  })
}
